"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isHandPickedOfficeProduct = void 0;
const EAvailableProduts_1 = require("../enums/Scpi/EAvailableProduts");
const HAND_PICKED_OFFICE_PRODUCTS = [EAvailableProduts_1.EAvailableProducts.hexa_scale_fund];
function isHandPickedOfficeProduct(referenceName) {
    return !!referenceName && HAND_PICKED_OFFICE_PRODUCTS.includes(referenceName);
}
exports.isHandPickedOfficeProduct = isHandPickedOfficeProduct;
